import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { RfqModel } from "@insite/client-framework/Types/ApiModels";
import { createRfq, CreateRfqApiParameter } from "@preconBlueprint/Services/PreconRfqService";

type HandlerType = ApiHandler<CreateRfqApiParameter & HasOnSuccess & HasOnError<string>, RfqModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SubmitRfqForm: HandlerType = async props => {
    try {
        props.apiResult = await createRfq(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const SetInitialValues: HandlerType = props => {
    props.dispatch(setInitialValues());
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    PopulateApiParameter,
    SubmitRfqForm,
    SetInitialValues,
    ExecuteOnSuccessCallback,
];

const preconSubmitRfqForm = createHandlerChainRunner(chain, "PreconSubmitRfqForm");
export default preconSubmitRfqForm;
